/**
 * Created by razial on 21.09.2026.
 */

cleverapps.overrideStyles(cleverapps.styles.LanternStartComponent, {
    bg: {
        scale9: {
            width: 583,
            height: 280
        }
    },

    lanternIcon: {
        y: { align: "center" }
    },

    helpButton: {
        x: { align: "right", dx: -11 },
        y: { align: "top", dy: -11 },
        scale: 0.8
    },

    label: {
        width: 300,
        height: 120,
        x: { align: "center", dx: 100 },
        y: { align: "center", dy: 55 }
    },

    progressBar: {
        x: { align: "center", dx: 100 }
    }
});
